import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import recentsModeles from "../../reducers/modeles/recents-modeles";
import corpusModeles from "../../reducers/modeles/corpus-modeles";
import { selectModele } from "../../actions";

const renderRecents = modele => (
    <option key={modele.id} value={`R${modele.id}`}>
        Nouv. {modele.dimension}
    </option>
);
const renderModeles = modele => (
    <option key={modele.id} value={modele.id}>
        Grille {modele.dimension} - n°{modele.no}
    </option>
);
const renderGroupes = (dimension, modeles) => (
    <optgroup key={dimension} label={`Grilles ${dimension}`}>
        {modeles.map(renderModeles)}
    </optgroup>
);
export default () => {
    const [selectedModele, setSelectedModele] = useState(
        useSelector(state => state.selectedModele)
    );

    useEffect(() => {
        location.hash = `#${selectedModele}`;
    }, []);
    const dispatch = useDispatch();
    const onModeleChange = e => {
        const value = e.target.value;
        const id = value.replace("R", "");

        setSelectedModele(value);
        dispatch(selectModele(id));
        location.hash = `#${id}`;
    };
    return (
        <select
            className="form-control btn-info"
            onChange={onModeleChange}
            value={selectedModele}
            title="Choisir un modèle"
        >
            <optgroup label="Nouveautés">
                {recentsModeles().map(renderRecents)}
            </optgroup>
            {corpusModeles().groupes.map(dimension => {
                const modeles = corpusModeles().modeles[`${dimension}`];
                return renderGroupes(dimension, modeles);
            })}
        </select>
    );
};
